import React from "react";
import "./matrimonyList.css";

interface PaymentActivationModalProps {
  open: boolean;
  onClose: () => void;
}

const PaymentActivationModal = ({ open, onClose }: PaymentActivationModalProps) => {
  if (!open) return null;

  return (
    <div className='payment-modal-overlay'>
      <div className='payment-modal'>
        <div className='payment-icon'>💍</div>

        <h2>Activate Your Profile</h2>

        <p>Your profile is currently inactive.</p>

        <p>
          Please complete your membership payment to activate your profile and start connecting with your perfect life
          partner faster ❤️
        </p>

        <div className='payment-details-box'>
          <h4>Payment Details</h4>

          <div className='payment-row'>
            <span>Payment Amount</span>
            <strong>₨ 25,000.00</strong>
          </div>

          <div className='payment-row'>
            <span>Bank</span>
            <strong>Commercial Bank</strong>
          </div>

          <div className='payment-row'>
            <span>Account Name</span>
            <strong>ABC Matrimony</strong>
          </div>

          <div className='payment-row'>
            <span>Account Number</span>
            <strong>1234567890</strong>
          </div>

          <div className='payment-row'>
            <span>Branch</span>
            <strong>Colombo Main Branch</strong>
          </div>
        </div>

        <div className='payment-modal-actions'>
          <button className='close-payment-btn' onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentActivationModal;
